import axiosInstance from "@/api/axiosInstance";
import { PublishResponse } from "../types";

/**
 * Unpublish a hero item
 * POST /api/admin/hero-items/{id}/unpublish
 */
export async function unpublishHeroItem(id: string): Promise<PublishResponse> {
  const response = await axiosInstance.post<PublishResponse>(
    `/api/admin/hero-items/${id}/unpublish`,
  );
  return response.data;
}
